module.exports = __webpack_public_path__ + "static/media/ppt-icon.57743774.svg";